import actionTypes from '../constants/action-types';

const setSiteData = (siteData) => ({
  type: actionTypes.SET_DATA,
  payload: { siteData },
});

export default setSiteData;
